import { Sparkles } from "lucide-react";

export default function ComingSoon({ title, blurb }) {
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="coming-soon">
            <p className="text-xs tracking-[0.28em] uppercase text-inkSoft mb-3">
                Bientôt disponible
            </p>
            <h1 className="font-serif text-3xl md:text-4xl tracking-tight" data-testid="coming-soon-title">
                {title}
            </h1>
            <p className="mt-4 text-base text-inkSoft leading-relaxed max-w-2xl">
                {blurb}
            </p>
            <div className="mt-10 inline-flex items-center gap-2 text-sm text-inkSoft border border-lexiBorder rounded-full px-4 py-2 bg-white">
                <Sparkles className="w-4 h-4 text-terracotta" />
                En cours de construction — merci de votre patience.
            </div>
        </div>
    );
}
